import { useQuery } from '@tanstack/react-query';
import SupportWidgetKeys from '../queryKeys';
import { getConversationsAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';
import transformFiltersForApi from '../utils/transformFiltersForApi';

const { getUserFeedback } = SupportWidgetKeys;

const fetchUserFeedback = async userFeedbackFilters => {
  const apiFilters = transformFiltersForApi(userFeedbackFilters);
  const { data } = await getConversationsAPI({
    ...apiFilters,
    hasCsatScore: true,
  });
  return data;
};

const useGetUserFeedbackQuery = userFeedbackFilters =>
  useQuery(
    [
      getUserFeedback,
      userFeedbackFilters.searchTerm,
      userFeedbackFilters.markedAsNotHelpful,
      userFeedbackFilters.page,
      userFeedbackFilters.limit,
      userFeedbackFilters.tags,
      userFeedbackFilters.csatScore,
      userFeedbackFilters.includeProductionHubs,
      userFeedbackFilters.includeSuperadmin,
      userFeedbackFilters.raisedTicket,
      userFeedbackFilters.flaggedInternally,
      userFeedbackFilters.dateRange?.start,
      userFeedbackFilters.dateRange?.end,
    ],
    () => fetchUserFeedback(userFeedbackFilters),
    {
      retry: false,
      onError: e => {
        notifyError(e, false, 'Error fetching user feedback');
      },
    }
  );

export default useGetUserFeedbackQuery;
